import { api } from '../createApi';
import { TagType } from '../TagType';

api.enhanceEndpoints({
  addTagTypes: [
    TagType.TicketRecipients as TagType,
    TagType.EsignatureEnvelope as TagType,
    TagType.EsignatureActivities as TagType,
  ],
  endpoints: {
    // Tickets
    getEnvelope: {
      providesTags: (_result, _error, arg) => [
        {
          type: TagType.EsignatureEnvelope,
          id: arg.ticketId,
        },
      ],
    },
    getRecipients: {
      providesTags: (_result, _error, arg) => [
        {
          type: TagType.TicketRecipients,
          id: arg.ticketId,
        },
      ],
    },
    assignSigner: {
      invalidatesTags: (_result, _error, arg) => [
        {
          type: TagType.TicketRecipients,
          id: arg.ticketId,
        },
      ],
    },
    sendReminder: {
      invalidatesTags: (_result, _error, arg) => [
        {
          type: TagType.TicketRecipients,
          id: arg.ticketId,
        },
      ],
    },
    getEsignatureActivities: {
      providesTags: (_result, _error, arg) => [
        {
          type: TagType.EsignatureActivities,
          id: arg.ticketId,
        },
      ],
    },
  },
});
